import { ERooms, TNumberInputs, ENewbuildingStatus } from '../../types/filters';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TThunkAction } from '../../types/redux/thunk';
import { newBuildingsChange } from '../newBuildings';

export enum EFiltersActionTypes {
  NewbuildingStatus = 'FILTERS/NEWBUILDING_STATUS',
  RegionChange = 'FILTERS/REGION_CHANGE',
  RoomsChange = 'FILTERS/ROOMS_CHANGE',
  MinPriceChange = 'FILTERS/MIN_PRICE_CHANGE',
  MaxPriceChange = 'FILTERS/MAX_PRICE_CHANGE',
  MinAreaChange = 'FILTERS/MIN_AREA_CHANGE',
  MaxAreaChange = 'FILTERS/MAX_AREA_CHANGE',
}

export type TNewbuildingStatusChange = ITypedReduxAction<EFiltersActionTypes.NewbuildingStatus, ENewbuildingStatus>;
export type TRegionChange = ITypedReduxAction<EFiltersActionTypes.RegionChange, number>;
export type TRoomsChange = ITypedReduxAction<EFiltersActionTypes.RoomsChange, ERooms[]>;
export type TMinPriceChange = ITypedReduxAction<EFiltersActionTypes.MinPriceChange, TNumberInputs>;
export type TMaxPriceChange = ITypedReduxAction<EFiltersActionTypes.MaxPriceChange, TNumberInputs>;
export type TMinAreaChange = ITypedReduxAction<EFiltersActionTypes.MinAreaChange, TNumberInputs>;
export type TMaxAreaChange = ITypedReduxAction<EFiltersActionTypes.MaxAreaChange, TNumberInputs>;

export type TFilterActions =
  | TNewbuildingStatusChange
  | TRegionChange
  | TRoomsChange
  | TMinPriceChange
  | TMaxPriceChange
  | TMinAreaChange
  | TMaxAreaChange;

export function newbuildingStatusChange(status: ENewbuildingStatus): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filters } = getState();

    dispatch(newBuildingsChange({ ...filters, newbuildingStatus: status }));
    dispatch({ type: EFiltersActionTypes.NewbuildingStatus, payload: status });
  };
}

export function regionChange(regionId: number): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filters } = getState();

    dispatch(newBuildingsChange({ ...filters, regionId }));
    dispatch({ type: EFiltersActionTypes.RegionChange, payload: regionId });
  };
}
export function roomsChange(rooms: ERooms[]): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filters } = getState();

    dispatch(newBuildingsChange({ ...filters, rooms }));
    dispatch({ type: EFiltersActionTypes.RoomsChange, payload: rooms });
  };
}
export function minPriceChange(minPrice: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filters } = getState();

    dispatch(newBuildingsChange({ ...filters, minPrice }));
    dispatch({ type: EFiltersActionTypes.MinPriceChange, payload: minPrice });
  };
}
export function maxPriceChange(maxPrice: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filters } = getState();

    dispatch(newBuildingsChange({ ...filters, maxPrice }));
    dispatch({ type: EFiltersActionTypes.MaxPriceChange, payload: maxPrice });
  };
}
export function minAreaChange(minArea: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filters } = getState();

    dispatch(newBuildingsChange({ ...filters, minArea }));
    dispatch({ type: EFiltersActionTypes.MinAreaChange, payload: minArea });
  };
}
export function maxAreaChange(maxArea: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filters } = getState();

    dispatch(newBuildingsChange({ ...filters, maxArea }));
    dispatch({ type: EFiltersActionTypes.MaxAreaChange, payload: maxArea });
  };
}
